import React, { useEffect, useState } from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import { Text } from '@fluentui/react/lib/Text';
import { AccountInfo } from '@azure/msal-browser';

export const WelcomeName = () => {
    const { accounts } = useMsal();
    const account = useAccount(accounts[0] as AccountInfo);
    const [name, setName] = useState("");

    useEffect(() => {
        if (account && account.name) {
            setName(account.name);
        } else {
            setName("");
        }
    }, [account]);

    if (name) {
        return <Text variant="mediumPlus">Welcome, {name}</Text>;
    } else {
        return null;
    }
};

export default WelcomeName;
